import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Table, Button, Spin, Dropdown, Menu } from 'antd';
import moment from 'moment-timezone';
import styles from './source-management.module.sass';
import Icon from '@ant-design/icons';
import { ReactComponent as three_dots_icon } from '../../../../assets/icons/ThreeDots.svg';
import { ReactComponent as no_results } from '../../../../assets/icons/no_results.svg';
import { ReactComponent as back_arrow } from '../../../../assets/icons/BackArrow.svg';
import mixpanel from 'mixpanel-browser';
import { STATUS } from '../../../../redux/constants';
import CreateFileFeedModal from '../../../AddNewFileFeedContainer/components/CreateFileFeedModal';
import { ColumnTitle } from '../../../../shared-components/ColumnTitle';
import { BackButton } from '../../../../shared-components/BackButton';
import { incrementUIRequestsCounter } from '../../../../redux/utils/websocket/incrementUIRequestsCounter';
import { useDispatch } from 'react-redux';

const ThreeDotsIcon = (props) => (
  <Icon
    component={three_dots_icon}
    style={{
      position: 'absolute',
      top: '-9px',
      right: '16px',
      fontSize: '16px',
      color: 'white !important',
      fill: 'white !important',
    }}
    {...props}
  />
);

const NoDataIcon = (props) => <Icon component={no_results} {...props} />;

const BackIcon = (props) => (
  <Icon style={{ fontSize: '16px' }} component={back_arrow} {...props} />
);

const SourceManagement = (props) => {
  const selectedScope = useRef('all');
  const [selectedSource, setSelectedSource] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [showCreateFileFeedModal, setShowCreateFileFeedModal] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    document.title = 'Feed Management - Silent Push';
    const queryParams = new URLSearchParams(props.location.search);
    let scope = queryParams.get('scope');
    let source_uuid = queryParams.get('source_uuid');
    if (source_uuid) {
      props.loadSource(source_uuid);
      props.loadIOCSFromSpecificCollection(source_uuid);
      incrementUIRequestsCounter();
    }
    selectedScope.current = scope;
  }, []);

  useEffect(() => {
    setSelectedSource(props?.source);
  }, [props?.source]);

  const SourceManagementDropdownMenu = (record) => {
    const loggedInUser = props?.user;
    const belongsToUser = selectedSource.user === loggedInUser?.id;
    const canDeleteIOC =
      (selectedSource.scope === 'GLOBAL' && belongsToUser) ||
      (selectedSource.scope !== 'GLOBAL' &&
        (selectedSource.organisation === loggedInUser?.organisation_id ||
          belongsToUser));
    return (
      <Menu className="ant-dropdown-menu">
        <Menu.Item
          style={{ height: '32px', marginTop: '8px', marginBottom: '0px' }}
          className="ant-dropdown-menu-item"
        >
          <Link
            onClick={() => props?.resetEnrichment()}
            aria-label={'enriching'}
            to={`/enrichment?name=${record?.record?.name}&type=${record?.record?.type}`}
            target="_blank"
            style={{ color: 'rgba(255,255,255,0.95)' }}
          >
            Enrich
          </Link>
        </Menu.Item>
        {canDeleteIOC && (
          <Menu.Item
            aria-label={'del1'}
            style={{ height: '32px', marginTop: '0px', marginBottom: '8px' }}
            className="ant-dropdown-menu-item"
            onClick={() => {
              props.deleteIOCFromCollection(
                record?.record?.uuid,
                selectedSource?.uuid,
              );
              incrementUIRequestsCounter();
            }}
          >
            <p style={{ color: 'red' }}>Delete</p>
          </Menu.Item>
        )}
      </Menu>
    );
  };

  const sourceManagementColumns = [
    {
      title: <ColumnTitle columnName="IOC Name" />,
      dataIndex: 'name',
      key: 'name',
      width: 500,
      sorter: (a, b) => a.name.localeCompare(b.name),
      render: (ioc, record) => (
        <div
          style={{
            wordWrap: 'break-word',
            wordBreak: 'break-word',
            textAlign: 'left',
            paddingLeft: 10,
          }}
        >
          {ioc}
        </div>
      ),
    },
    {
      title: <ColumnTitle columnName="IOC Type" />,
      dataIndex: 'type',
      key: 'type',
      sorter: (a, b) => a.type.localeCompare(b.type),
    },
    {
      title: <ColumnTitle columnName="Last Seen" />,
      dataIndex: 'last_seen_on',
      key: 'last_seen_on',
      //...getColumnDateFilterProps('last_seen'),
      sorter: (a, b) => moment(a.last_seen) - moment(b.last_seen),
      render: (text) => {
        let datetime = 'No available timestamp';
        if (text !== null) {
          datetime = moment.utc(text).format('YYYY-MM-DD HH:mm').toString();
        }

        return datetime;
      },
    },

    {
      title: '',
      key: 'actions',
      render: (record) => (
        <div className={styles.action_buttons}>
          {/* <ShareIcon /> */}

          <Dropdown
            trigger={['click']}
            overlay={<SourceManagementDropdownMenu record={record} />}
          >
            <div>
              <ThreeDotsIcon />
            </div>
          </Dropdown>
        </div>
      ),
    },
  ];

  const handleFileUploadClick = () => {
    setShowCreateFileFeedModal(true);
    mixpanel.track('Source Add File Attempt', {
      feed_type: selectedSource?.type,
    });
  };

  const handleBackClick = () => {
    if (selectedSource) {
      props.history.push(
        'sources/' +
          selectedSource.state.toLowerCase() +
          '?scope=' +
          selectedScope.current,
      );
    }
  };

  const onCancel = () => {
    setShowCreateFileFeedModal(false);
  };

  const onUpdate = () => {
    onCancel();
  };

  const onCreate = () => {
    onCancel();
  };

  return (
    <div className={styles.explore_recipe_pane}>
      {/* <div className="threatRankingBackButton"> */}
      {/* <span className={styles.back_button} onClick={handleBackClick}>
          <BackIcon
            style={{ position: 'relative', top: '2px', fontSize: '16px' }}
          />
          <span
            style={{
              position: 'absolute',
              top: '4px',
              left: '20px',
              marginLeft: '16px',
              fontSize: '12px',
            }}
          >
            Back
          </span>
        </span> */}
      {/* </div> */}
      <BackButton />

      {showCreateFileFeedModal ? (
        <CreateFileFeedModal
          state={selectedSource.state}
          feedTable={props.feedTable}
          feedItemFields={props.feedItemFields}
          consumeStatus={props.consumeStatus}
          consumeFileData={props.consumeFileData}
          loadCollection={props.loadSource}
          createFileSource={props.createFileSource}
          updateFileSource={props.updateFileSource}
          foundTags={props.foundTags}
          searchStatus={props.searchStatus}
          searchForTags={props.searchForTags}
          resetTagSearch={props.resetTagSearch}
          selectedSourceToEdit={selectedSource}
          onCancel={onCancel}
          onUpdate={onUpdate}
          onCreate={onCreate}
        />
      ) : (
        ''
      )}

      <div style={{ marginTop: '15px' }}>
        <p
          style={{
            position: 'absolute',
            left: '10px',
            marginBottom: '32px',
            marginTop: '10px',
            color: 'rgba(255,255,255,0.95)',
            fontSize: '16px',
            zIndex: 99,
            fontWeight: 700,
          }}
        >
          {selectedSource?.name}
        </p>
        <div
          style={{
            position: 'relative',
            height: '50px',
            borderLeft: '2px solid #606F74',
            borderRight: '2px solid #606F74',
            borderTop: '2px solid #606F74',
            background: '#1C3138',
          }}
        >
          <div
            style={{
              zIndex: 99,
              right: '7px',
              top: '7px',
              position: 'absolute',
            }}
          >
            <Button
              aria-label={'addfileBtn'}
              onClick={() => handleFileUploadClick()}
            >
              Add New File
            </Button>
          </div>
        </div>

        {props?.feedIOCListStatus === STATUS.LOADED ||
        props?.feedIOCListStatus === STATUS.ERROR ? (
          <Table
            locale={{
              emptyText:
                props?.feedIOCListStatus === STATUS.LOADING ? (
                  <Spin style={{ margin: 40 }} />
                ) : (
                  <div style={{ marginTop: '10px' }}>
                    {selectedSource?.data_source !== 'URL' ? (
                      <span>
                        <NoDataIcon style={{ fontSize: 32 }} />
                        <p
                          style={{
                            color: 'rgba(255, 255, 255, 0.95)',
                            fontFamily: 'TT Hoves',
                            fontWeight: 600,
                            fontSize: '14px',
                            lineHeight: '19px',
                            fontStyle: 'normal',
                          }}
                        >
                          No IOCs yet. To add a file to the source click on{' '}
                          <span
                            aria-label={'addFileTxt'}
                            style={{
                              color: '#3C9AE8',
                              //display: 'inline',
                              //color: 'rgba(255, 255, 255, 0.95)',
                            }}
                            onClick={() => handleFileUploadClick()}
                          >
                            add new file
                          </span>
                          .
                        </p>
                      </span>
                    ) : (
                      <span>
                        <p
                          style={{
                            color: 'rgba(255, 255, 255, 0.95)',
                            fontFamily: 'TT Hoves',
                            fontWeight: 600,
                            fontSize: '14px',
                            lineHeight: '19px',
                            fontStyle: 'normal',
                          }}
                        >
                          URL source IOCs can be managed through the remote
                          source.{' '}
                        </p>
                      </span>
                    )}
                    )
                  </div>
                ),
            }}
            dataSource={props?.feedIOCList}
            rowKey={(record) => record?.uuid}
            pagination={{
              total: props?.feedIOCListCount,
              current: currentPage,
              pageSize: 100,
              onChange: (current, pageSize) => {
                props.loadIOCSPageFromSpecificCollection(
                  selectedSource.uuid,
                  current,
                );
                setCurrentPage(current);
              },
            }}
            columns={sourceManagementColumns}
          />
        ) : (
          <Spin style={{ margin: 40 }} />
        )}
      </div>
    </div>
  );
};

export default SourceManagement;
